import { makeStyles } from "@mui/styles";

const companyVisionStyle = makeStyles((theme) => ({
  detailsContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100% ",
    alignItems: "center",
    backgroundColor: theme.palette.background.gray,
    paddingLeft: '11.1rem',
    paddingRight: '11.1rem',
    [theme.breakpoints.down('lg')]: {
      paddingRight: '7.5rem',
      paddingLeft: '7.5rem',
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0rem',
      paddingLeft: '0rem',
    },
  },
  detailsSection: {
    backgroundColor: 'rgba(95, 89, 89, 0.16)',
    borderColor: 'rgba(95, 89, 89, 0.47)',
    borderRadius: "15px",
    paddingTop: '3rem',
    paddingRight: '4rem',
    paddingLeft: '4rem',
    paddingBottom: '1rem',
    alignItems: "center",
    boxShadow: "0px 8px 16px rgba(0,0,0,0.2)",
    animation: "$fadeInAnimation 1s ease-in-out forwards",
    [theme.breakpoints.down('lg')]: {
      paddingTop: "4rem",
      paddingBottom: "2rem",
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '2rem',
      paddingLeft: '2rem',
      borderRadius: "40px",
    },
  },
  "@keyframes fadeInAnimation": {
    "0%": {
      opacity: 0,
      transform: "translateY(50px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  header: {
    fontSize: "1.8rem !important",
    marginBottom: "2rem !important",
    textAlign: "left",
    width: "100%",
    color: '#2b3a56',
    [theme.breakpoints.down('lg')]: {
      paddingTop:"0rem",
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: "center",
      fontSize: "1.73rem!important",
    },
  },
  fullWidthParagraph: {
    fontSize: "1.1rem!important",
    lineHeight: "1.6",
    marginBottom: "2rem!important",
    textAlign: "justify",
    width: "100%",
    [theme.breakpoints.down('sm')]: {
      fontSize: "1.3rem!important",
    },
  },
  textContainer: {
    display: "flex",
    gap: "3rem",
    width: "100%",
    marginBottom: "3rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "1.5rem",
    },
  },
  textColumn: {
    flex: 1,
    textAlign: "justify",
  },
  subHeading: {
    fontSize: "1.4rem!important",
    fontWeight: "bold",
    marginBottom: "1rem!important",
    color: "#2b3a56",
    [theme.breakpoints.down('sm')]: {
      fontSize: "1.6rem!important",
      marginBottom: "2rem!important",
      marginTop: "2rem!important",
    },
  },
  paragraph: {
    fontSize: "1.1rem!important",
    lineHeight: "1.5",
    textAlign: "justify",
    color: '#2b3a56',
    marginBottom: "1rem",
    [theme.breakpoints.down('sm')]: {
        fontSize: "1.3rem!important",
    },
  },
  imageContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginTop: "2rem",
  },
  detailsImage: {
    width: "100%",
    height: "500px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "10px",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down('sm')]: {
        width: "100%",
        height: "300px",
        borderRadius: "15px",
    },
  },
  imageCopyright: {
    position: "absolute",
    bottom: "8px",
    right: "10px",
    fontSize: "0.8rem",
    color: "#fff",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "4px 8px",
    borderRadius: "5px",
    [theme.breakpoints.down('sm')]: {
      right: "0px!important",
    },
  },
  collapseButton: {
    marginTop: "2rem!important",
    color: "#2b3a56!important",
    border: "none",
    cursor: "pointer",
    index:1000,
    "& svg": {
      fontSize: "2.5rem!important",
    },
    "&:hover": {
      color: "#ffff!important",
    },
  },
}));

export default companyVisionStyle;